import { get, post, put } from "../Config"

export function SearchCustomer({ params }) {
  return get({ url: `/api/hu/v1/customer`, params })
}
export function GetCustomerByIds({ params, data }) {
  return post({ url: `/api/hu/v1/customerByIds`, params, data })
}

export function GetTierList({ params }) {
  return get({ url: `/api/hu/v1/customer/tier`, params })
}
